import React, {Component} from 'react';
import {HashRouter as Router, Route} from 'react-router-dom';
import theme from '../../utils/style/theme';
import {GlobalStyle} from '../../utils/style/base';
import {ThemeProvider} from 'styled-components';
import UnitInstitution from '../Mall/index';
import { sendSgmMta, SgmConfig } from '../../utils/sgm';


class App extends Component {
  componentDidMount() {
    window.onerror = (error, info) => {
      const isScriptError = JSON.stringify(error).includes('Script error');
      if (isScriptError) {
        sendSgmMta(SgmConfig.Error.scriptError, {
          message: 'script error',
          errorMessage: error && error.message ? error.message : '',
          data: JSON.stringify(info),
        });
      } else {
        sendSgmMta(SgmConfig.Error.jsError, {
          message: 'js错误',
          errorMessage: error && error.message ? error.message : '',
          data: JSON.stringify(info),
        });
      }
    };

    window.onunhandledrejection = (event) => {
      sendSgmMta(SgmConfig.Error.jsError, {
        message: '未处理的Promise错误',
        errorMessage: JSON.stringify(event) || '',
        data: JSON.stringify(event),
      });
    };
  }
  render() {
    return (
      <Router>
        <ThemeProvider theme={theme}>
          <div>
            <GlobalStyle/>
            <Route exact path="/mall/:vendorId" component={UnitInstitution}/>
          </div>
        </ThemeProvider>
      </Router>
    );
  }
}

export default App;
